const getStudentsData = applications => {
  const studentsData = applications
    .filter(application => {
      const userId = application.user_id;
      const maxGradeApplication = applications.reduce(
        (a, b) =>
          parseFloat(a.final_grade) > parseFloat(b.final_grade) ||
          b.user_id !== userId
            ? a
            : b,
        { id: null, final_grade: "-1.00" }
      );

      if (application.id === maxGradeApplication.id) return true;

      return false;
    })
    .map(application => ({
      id: application.id,
      usuId: application.user_id,
      nome: application.name,
      foto: application.user_photo,
      nota: parseFloat(application.final_grade)
    }));

  return studentsData;
};

export default getStudentsData;
